












































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DxAutocomplete } from "devextreme-vue";
import Card from "@/components/default/Card.vue";
import notificationService from "@/services/notificationService";

import { DxForm, DxSimpleItem, DxLabel } from "devextreme-vue/form";
import { DxSlider } from "devextreme-vue/slider";
import {
  IMeasuringStateRating,
  MeasuringStateRatingItemInfoDto,
} from "@/data/web-api-client";

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    DxSlider,
  },
})
export default class MeasuringStateRating extends Vue {
  @Prop({ required: true })
  measuringStateRating!: MeasuringStateRatingItemInfoDto;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  private tooltip: any = {
    enabled: true,
  };

  private label: any = {
    visible: true,
  };

  private mounted() {
  }

  private onValueChanged(e: any){
    this.$emit('changes');
  }
}
